import { z } from 'zod';

import { CapacityType } from 'types/event.types';

export const CapacityModalSchema = z.object({
  maxAttendees: z.coerce
    .number({
      invalid_type_error: 'Capacity must be a number'
    })
    .int()
    .positive('Capacity must be a positive number')
    .optional()
    .nullable(),
  capacityType: z.nativeEnum(CapacityType).optional()
});

export type CapacityModalFormValues = z.infer<typeof CapacityModalSchema>;
